/**
 *
 *
 *
 *
 *
 */
window.o_global.pali.DropButton = function DropButton(trigger) {
  const _self = this;

  /*                                                */
  if (!(this instanceof window.o_global.pali.DropButton)) {
    return new window.o_global.pali.DropButton(trigger);
  }

  this.id = null;
  this.trigger = trigger;
  this.container = trigger.parentNode;
  this.content = document.createElement("div");
  this.loader = document.createElement("div");
  this.loader.classList.add("p_loader100");
  this.loader.style.margin = "0 auto";
  this.isOpen = false;
  this.orientation = this.trigger.getAttribute("data-trigger-pos");
  this.openCallback = this.trigger.getAttribute("data-open-callback");
  this.closeCallback = this.trigger.getAttribute("data-close-callback");
  this.loadContent = undefined;
  this.hasStaticContent = false;

  /*                                                                        */
  if (this.openCallback) {
    this.openCallback = window.o_util.core.convertStringToFunction(this.openCallback, window);
  }

  if (this.closeCallback) {
    this.closeCallback = window.o_util.core.convertStringToFunction(this.closeCallback, window);
  }

  /*                                          */
  if (this.orientation === "left") {
    this.content.classList.add("p_dropBtn__content--left");
  } else {
    this.content.classList.remove("p_dropBtn__content--left");
  }

  /**
 *
 *
 *
 *
 *
 */
  function _calculatePosition() {
    const triggerRect = _self.trigger.getBoundingClientRect();
    const contentRect = _self.content.getBoundingClientRect();
    const leftSpace = triggerRect.left;
    const rightSpace = window.o_global.device.screen.getWidth() - triggerRect.right;
    const overlapSpace = contentRect.width - triggerRect.width;
    const hasLeftAlignment = _self.content.classList.contains("p_dropBtn__content--left");

    /*                                                                                       */
    if (leftSpace < overlapSpace && rightSpace < overlapSpace) {
      if (leftSpace > rightSpace) {
        if (hasLeftAlignment) {
          _self.content.classList.remove("p_dropBtn__content--left");
        }
      } else if (leftSpace < rightSpace) {
        if (!hasLeftAlignment) {
          _self.content.classList.add("p_dropBtn__content--left");
        }
      }
    } else {
      /*                                                                                             */
      if (!hasLeftAlignment && leftSpace < overlapSpace) {
        _self.content.classList.add("p_dropBtn__content--left");
      } else if (hasLeftAlignment && rightSpace < overlapSpace) {
        _self.content.classList.remove("p_dropBtn__content--left");
      }
    }
  }

  /**
 *
 *
 *
 *
 */
  function _finishLoadingProcess() {
    _self.isOpen = true;

    if (_self.openCallback) {
      _self.openCallback();
    }

    _calculatePosition();
  }

  /**
 *
 *
 *
 *
 *
 */
  function _loadStaticContent(id) {
    const contentElement = document.getElementById(id);

    /*                                                                     */
    /*                                         */
    if (!_self.content.hasChildNodes()) {
      contentElement.classList.remove("p_dropBtn__content--hidden");

      /*                                      */
      contentElement.removeAttribute("style");

      /*                                          */
      _self.content.appendChild(contentElement);

      /*                                               */
      _self.hasStaticContent = true;
    } else {
      _self.content.classList.remove("p_dropBtn__content--hidden");
    }

    _finishLoadingProcess();
  }

  /**
 *
 *
 *
 *
 *
 */
  function _loadContentFromUrl(url) {
    /*                                   */
    /*                                                                                              */
    while (_self.content.firstChild) {
      _self.content.removeChild(_self.content.firstChild);
    }

    _self.content.appendChild(_self.loader);

    window.o_util.ajax.get(url, function (ajaxResult) {
      if (ajaxResult.status !== 200) {
        _self.container.classList.add("p_dropBtn--error");
      }

      _self.content.innerHTML = ajaxResult.responseText;
      _finishLoadingProcess();
    });
  }

  /**
 *
 *
 *
 */
  function _loadContent() {
    const contentId = _self.trigger.getAttribute("data-content-id");
    const dataUrl = _self.trigger.getAttribute("data-url");

    _self.container.classList.add("p_dropBtn--open");

    /*                                   */
    _self.container.appendChild(_self.content);

    if (dataUrl) {
      _loadContentFromUrl(dataUrl);
    } else if (contentId) {
      _loadStaticContent(contentId);
    }
  }

  this.loadContent = _loadContent;

  this.content.classList.add("p_dropBtn__content");
};

/**
 *
 *
 */
window.o_global.pali.DropButton.prototype.open = function () {
  /*                                                                                    */
  if (!this.trigger.disabled) {
    this.loadContent();
  }
};

/**
 *
 */
window.o_global.pali.DropButton.prototype.close = function () {
  if (this.isOpen) {
    this.container.classList.remove("p_dropBtn--open", "p_dropBtn--error");
    if (!this.hasStaticContent) {
      this.container.removeChild(this.content);
    } else {
      this.content.classList.add("p_dropBtn__content--hidden");
    }

    this.isOpen = false;
    if (this.closeCallback) {
      this.closeCallback();
    }
  }
};

/**
 *
 */
window.o_global.pali.DropButton.prototype.toggle = function () {
  if (this.isOpen) {
    this.close();
  } else {
    this.open();
  }
};

/**
 *
 *
 *
 *
 *
 */
window.o_global.pali.DropButtonHandler = function () {
  const _self = this;

  /*                                                */
  if (!(this instanceof window.o_global.pali.DropButtonHandler)) {
    return new window.o_global.pali.DropButtonHandler();
  }

  this.dropButtonList = {};
  this.dropButtonCount = 0;

  /**
 *
 *
 *
 *
 *
 */
  function _initDropButton(event) {
    const trigger = event.target;
    const isValidTrigger = window.o_util.misc.isValidMouseButton(event, 1);
    let dropButton;
    let dropButtonId;

    /*                                                                      */
    if (!!trigger && !!isValidTrigger) {
      /*                                 */
      dropButton = new window.o_global.pali.DropButton(trigger);

      /*                           */
      dropButtonId = `dropBtn-${_self.dropButtonCount}`;

      /*                                       */
      dropButton.container.setAttribute("data-dropbtn-id", dropButtonId);

      /*                                   */
      trigger.classList.remove("js_openDropBtn");

      /*                                                                      */
      _self.dropButtonCount += 1;
      _self.dropButtonList[dropButtonId] = dropButton;

      /*                                           */
      dropButton.open();

      /*                                        */
      window.o_util.event.stop(event);

      /*                                           */
      trigger.addEventListener("click", function () {
        dropButton.toggle();
      });
    }
  }

  /*                                                   */
  /*                                                                                */
  window.o_global.eventLoader.onReady(40, function () {
    window.o_util.event.delegate("body", "click", ".js_openDropBtn", function (event) {
      _initDropButton(event);
    });
  });
};

/**
 *
 *
 *
 *
 *
 */
window.o_global.pali.DropButtonHandler.prototype.getInstance = function (id) {
  return id ? this.dropButtonList[id] : undefined;
};

/**
 *
 *
 *
 *
 *
 *
 */
window.o_global.pali.DropButtonHandler.prototype.close = function (id) {
  this.getInstance(id).close();
};

/**
 *
 *
 *
 */
window.o_global.pali.dropBtnHandler = new window.o_global.pali.DropButtonHandler();
